function ReferenceCcchaTeaController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	function initSliders(){
		var iconSlider = new Swiper('#icon-slider', {
			effect: 'fade',
			slidesPerView: 1,
			speed: 700,
			loop: true,
			autoplay: {
				delay: 2500
			}
		});		
		
		var boxSlider = new Swiper('#box-slider', {
			effect: 'slide',
			slidesPerView: 1,
			speed: 500,
			loop: true,
			autoplay: false
		});		
	}

   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// init
			initSliders();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
